var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { key: _vm.componentKey, staticClass: "dashboardIFrame" }, [
    _vm.renderPowerbiDashboard && _vm.forceRendering
      ? _c("section", { attrs: { id: "powerbi-dashboard" } })
      : _vm._e(),
    _vm._v(" "),
    _c("iframe", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.renderDremioDashboard,
          expression: "renderDremioDashboard",
        },
      ],
      ref: "iframe",
      attrs: {
        id: "iframe",
        src: _vm.formatedURL,
        width: "100%",
        height: "100%",
        border: "0",
        frameborder: "0",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }